//import ml5 from 'ml5';

// @ts-ignore
import preload from '../assets/ml5-preload.svg';
import { LoggerService } from './LoggerService';

class ML5Class {
  private started: boolean = false;
  public classifier: any;
  public faceapi: any;

  constructor() {}

  public start() {
    if (!this.started) {
      this.started = true;

      //const modelPath = store.modelsPath;
      // ml5.setBackend('webgl');
      // this.classifier = ml5.imageClassifier(modelPath, this.imageClassifierLoaded);
      // this.faceapi = ml5.faceMesh({ maxFaces: 1, refineLandmarks: false, flipped: false }, this.faceApiLoaded);

      // //warmup
      // const img = new Image();
      // img.src = preload;
      // this.classifier.classify(img, this.gotResults);
      // this.faceapi.detect(img, this.gotResults);
    }
  }

  public imageClassifierLoaded() {
    LoggerService.log('ML5 imageClassifierLoaded LOADED!!!');
  }

  public faceApiLoaded() {
    LoggerService.log('ML5 faceApiLoaded LOADED!!!');
  }

  public gotResults(results: any) {
    LoggerService.log(results);
  }
}

export const ML5 = new ML5Class();
